/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_CopiedInputs */

const en_check_in_copied = /** @type {(inputs: Check_In_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copied`)
};

const es_check_in_copied = /** @type {(inputs: Check_In_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt copiado`)
};

/**
* | output |
* | --- |
* | "Prompt copied" |
*
* @param {Check_In_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_copied = /** @type {((inputs?: Check_In_CopiedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_CopiedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_copied(inputs)
	return es_check_in_copied(inputs)
});